import { Component } from '@angular/core'
import { IcosFormProps } from './form.props'

@Component({
  selector: 'icos-form',
  template: `
    <form [class]="'icos-form ' + (labelPosition ? 'icos-form--label-' + labelPosition : '')
      + (inline ? ' icos-form--inline' : '')">
     <ng-content></ng-content>
    </form>
  `,
})
export class IcosForm extends IcosFormProps {
  constructor() {
    super()
  }
}
